import { carouselSettings, makeSlides } from "./EnergyCarousel.utils";
import {
  CarouselContainer,
  CarouselContent,
  InfoTooltipContainer,
} from "./EnergyCarousel.styles";
import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import Slider from "react-slick";
import React, { useState } from "react";

import "./css/_slick.css";
import "./css/_slickTheme.css";
import { InfoOutlined } from "@material-ui/icons";
import { StyledTooltip } from "../../SchoolProfileView.styled";

export const EnergyCarousel = ({
  totalEnergyGenerated = false,
  totalCo2Saved = false,
  totalGridConsumption = false,
  totalEmissions = false,
  schoolStartDate,
}) => {
  const slides = makeSlides(
    totalCo2Saved,
    totalEnergyGenerated,
    totalGridConsumption,
    totalEmissions
  );

  const [currentTooltip, setCurrentTooltip] = useState(slides[0].info);

  const handleChange = (index) => {
    setCurrentTooltip(slides[index].info);
  };

  return (
    <CarouselContainer>
      <InfoTooltipContainer>
        <StyledTooltip title={currentTooltip}>
          <InfoOutlined />
        </StyledTooltip>
      </InfoTooltipContainer>
      <Slider {...carouselSettings} afterChange={handleChange}>
        {slides.map((slide, index) => (
          <Box key={index}>
            <CarouselContent>
              {slide.text}
              <img src={`/img/schools/slide/${slide.img}.png`} height="125px" />
              <Typography variant="caption">Since {schoolStartDate}</Typography>
            </CarouselContent>
          </Box>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

EnergyCarousel.propTypes = {
  totalEnergyGenerated: PropTypes.number,
  totalCo2Saved: PropTypes.number,
  totalGridConsumption: PropTypes.number,
  totalEmissions: PropTypes.number,
  schoolStartDate: PropTypes.string,
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/EnergyCarousel/EnergyCarousel.js